/* tslint:disable */
/* eslint-disable */
/**
 * Proxy microservice (dev)
 * Proxy microservice for application
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FamilyDTO } from './FamilyDTO';
import {
    FamilyDTOFromJSON,
    FamilyDTOFromJSONTyped,
    FamilyDTOToJSON,
} from './FamilyDTO';
import type { Pageable } from './Pageable';
import {
    PageableFromJSON,
    PageableFromJSONTyped,
    PageableToJSON,
} from './Pageable';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * 
 * @export
 * @interface FamilyPageDTO
 */
export interface FamilyPageDTO {
    /**
     * 
     * @type {Array<FamilyDTO>}
     * @memberof FamilyPageDTO
     */
    content?: Array<FamilyDTO>;
    /**
     * 
     * @type {boolean}
     * @memberof FamilyPageDTO
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof FamilyPageDTO
     */
    last?: boolean;
    /**
     * 
     * @type {number}
     * @memberof FamilyPageDTO
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof FamilyPageDTO
     */
    numberOfElements?: number;
    /**
     * 
     * @type {Pageable}
     * @memberof FamilyPageDTO
     */
    pageable?: Pageable;
    /**
     * 
     * @type {number}
     * @memberof FamilyPageDTO
     */
    size?: number;
    /**
     * 
     * @type {Sort}
     * @memberof FamilyPageDTO
     */
    sort?: Sort;
    /**
     * 
     * @type {number}
     * @memberof FamilyPageDTO
     */
    totalElements?: number;
    /**
     * 
     * @type {number}
     * @memberof FamilyPageDTO
     */
    totalPages?: number;
}

/**
 * Check if a given object implements the FamilyPageDTO interface.
 */
export function instanceOfFamilyPageDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function FamilyPageDTOFromJSON(json: any): FamilyPageDTO {
    return FamilyPageDTOFromJSONTyped(json, false);
}

export function FamilyPageDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): FamilyPageDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': !exists(json, 'content') ? undefined : ((json['content'] as Array<any>).map(FamilyDTOFromJSON)),
        'first': !exists(json, 'first') ? undefined : json['first'],
        'last': !exists(json, 'last') ? undefined : json['last'],
        'number': !exists(json, 'number') ? undefined : json['number'],
        'numberOfElements': !exists(json, 'numberOfElements') ? undefined : json['numberOfElements'],
        'pageable': !exists(json, 'pageable') ? undefined : PageableFromJSON(json['pageable']),
        'size': !exists(json, 'size') ? undefined : json['size'],
        'sort': !exists(json, 'sort') ? undefined : SortFromJSON(json['sort']),
        'totalElements': !exists(json, 'totalElements') ? undefined : json['totalElements'],
        'totalPages': !exists(json, 'totalPages') ? undefined : json['totalPages'],
    };
}

export function FamilyPageDTOToJSON(value?: FamilyPageDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content === undefined ? undefined : ((value.content as Array<any>).map(FamilyDTOToJSON)),
        'first': value.first,
        'last': value.last,
        'number': value.number,
        'numberOfElements': value.numberOfElements,
        'pageable': PageableToJSON(value.pageable),
        'size': value.size,
        'sort': SortToJSON(value.sort),
        'totalElements': value.totalElements,
        'totalPages': value.totalPages,
    };
}

